import React, { Component } from 'react'
import styled from 'styled-components'
import * as constants from 'app/lib/constants'
import colors from 'app/lib/colors'

import NextButton from './NextButton'

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;
  margin: 0 30px;

  @media (min-width: ${constants.MOBILE_MAX_WIDTH}px) {
    margin: 0 85px;
  }
`

const Options = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`

const Option = styled.li`
  list-style-type: none;
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  cursor: pointer;
`

const circleSize = 25
const OptionCircle = styled.div`
  width: ${circleSize}px;
  height: ${circleSize}px;
  border-radius: ${circleSize / 2}px;
  border: 1px ${colors.gray} solid;
  margin-right: 15px;
  margin-top: 12px;

  &.selected {
    border: 1px ${props => props.partner.primary_color} solid;
    background-color: ${props => props.partner.primary_color};
  }

  &.square {
    border-radius: 0;
  }
`

const OptionContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px;
`

const OptionLabel = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.partner.primary_color};
`

const OptionDescription = styled.div`
  font-size: 12px;
  color: ${colors.gray};
  margin-top: 5px;
  max-width: 400px;
`

export default class QuestionMultipleSelect extends Component {
  state = {
    values: []
  }

  handleOptionClick = option => {
    const idx = this.state.values.indexOf(option.value)
    let updatedValues = this.state.values.filter(v => v !== option.value)
    if (idx === -1) {
      updatedValues = updatedValues.concat([option.value])
    }
    if (option.value === null) {
      updatedValues = []
    }
    this.setState({
      values: updatedValues
    })
  }

  renderOption(option) {
    const selected =
      option.value === null ? this.state.values.length === 0 : this.state.values.indexOf(option.value) !== -1
    const isSquare = option.value !== null
    return (
      <Option key={option.value} onClick={() => this.handleOptionClick(option)}>
        <OptionCircle {...this.props} className={`${selected ? 'selected' : ''} ${isSquare ? 'square' : ''}`} />
        <OptionContent>
          <OptionLabel {...this.props}>{option.label}</OptionLabel>
          <OptionDescription>{option.description}</OptionDescription>
        </OptionContent>
      </Option>
    )
  }

  render() {
    const { step } = this.props
    return (
      <Wrap>
        <Options>{step.options.map(option => this.renderOption(option))}</Options>
        <NextButton {...this.props} onClick={() => this.props.onSubmit(this.state.values)} />
      </Wrap>
    )
  }
}
